export default __webpack_public_path__ + "static/media/band15.f238fa2e.jfif";